const EMBED_ORIGINS = ['https://www.youtube-nocookie.com/', 'https://player.vimeo.com/'];

/**
 * The company's video, embedded from the URL the API built.
 *
 * Never the raw `video.url` the company typed: the API derives `embed_url`
 * from the parsed video id, so the iframe can only ever point at one of two
 * player origins. The origin check here is a second fence, not the first.
 */
export function BrandVideo({ video, companyName }) {
  const src = video?.embed_url;
  if (!src || !EMBED_ORIGINS.some((origin) => src.startsWith(origin))) return null;

  return (
    <div className="aspect-video w-full overflow-hidden rounded-lg bg-black">
      <iframe
        src={src}
        title={`${companyName ?? 'Company'} video`}
        className="size-full"
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
        allow="encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
      />
    </div>
  );
}
